import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`THE INCREDIBLE ORDINARY`}</h2>
    <p>{`War and displacement have put the most ordinary things out of reach for many refugees living in Turkey. Even the most basic choices we make every day – like buying food for dinner or picking a birthday gift for a family member – have become incredible for them. `}</p>
    <p>{`To help EU citizens understand what life is like for refugees in Turkey and how the ESSN programme helped them, WFP and the EU created the Incredible Ordinary campaign, which launched in 2018 and continued in 2019. `}</p>
    <p>{`Through pop-up shops set up across major European cities – from Paris, Milan and Brussels to Warsaw, Berlin and Amsterdam – and a video series that told the stories of eight Syrian refugee families, the campaign showcased how the ESSN card allowed these refugees to make again some seemingly ordinary decisions that have incredible meaning to them.`}</p>
    <p>{`The Incredible Ordinary successfully reached audiences in France, Italy, Poland, Germany and the Netherlands with stories of how European solidarity with refugees, manifested through the ESSN, brought back a sense of normalcy to the lives of the most vulnerable Syrians living in Turkey.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      